import { getStore } from "../store/Store";

/**
 * Returns a flag indicating whether to show all accounts node (Unified Inbox) or not
 * @return boolean - true if all accounts node should be shown, false otherwise
 * @remarks Since UnifiedInbox does not belong to any specific account, we will use local storage to persist the state and this is initialized based
 * on the local storage value in initializeMailLayout function in owa-mail-layout package
 */
export function shouldShowAllAccountsNode(): boolean {
    return getStore().showAllAccountsNode;
}
